import React from "react";

const SurveryResults = (props: any) => {
  return (
    <svg
      width="100%"
      height="100"
      viewBox="0 0 57 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.333374 31.3333V62H20.4667C33.4 62 40.2 61.4667 39.6667 60.6667C39.1334 59.8667 31.4 59.3333 20.8667 59.3333H3.00004V31.3333V3.33333H15.6667H28.3334V12V20.6667H37H45.6667V28.6667C45.6667 33.0667 46.2 36.6667 47 36.6667C47.8 36.6667 48.3334 32.8 48.3334 27.6V18.5333L39.2667 9.6L30.2 0.666663H15.2667H0.333374V31.3333ZM43 17.6C43 17.8667 40.3334 18 37 18H31V11.7333V5.46666L37 11.3333C40.3334 14.5333 43 17.3333 43 17.6Z"
        fill="black"
      />
      <path
        d="M17.1334 28.9333L20.7334 34.6666L17.2667 40.9333L13.6667 47.3333H16.8667C19.1334 47.3333 20.4667 46.1333 21.6667 43.3333C22.6001 41.0666 23.8001 39.3333 24.3334 39.3333C24.8667 39.3333 26.0667 41.0666 27.0001 43.3333C28.2001 46.2666 29.5334 47.3333 31.9334 47.3333H35.2667L31.6667 41.3333L28.2001 35.2L31.6667 29.3333L35.1334 23.3333H31.9334C29.6667 23.3333 28.2001 24.5333 26.7334 27.6L24.7334 32L22.4667 27.6C20.8667 24.5333 19.4001 23.3333 17.0001 23.3333H13.6667L17.1334 28.9333Z"
        fill="black"
      />
      <path
        d="M41.6667 45.3333C41.6667 50.9333 41.4 51.3333 38.2 51.3333C34.8667 51.3333 35 51.4667 40.6 58L46.2 64.5333L51.8 58.2667C57.2667 52.1333 57.2667 52 54.2 51.6C51.4 51.2 51 50.5333 51 45.2C51 39.3333 51 39.3333 46.3333 39.3333C41.6667 39.3333 41.6667 39.3333 41.6667 45.3333ZM48.3333 47.8667C48.3333 51.0667 49 54 49.8 54.2667C50.7333 54.5333 50.2 56 48.7333 57.8667L46.0667 61.0667L43.8 57.8667C42.6 56 42.2 54.5333 43 54.2667C43.6667 54 44.3333 51.0667 44.3333 47.8667C44.3333 43.6 44.8667 42 46.3333 42C47.8 42 48.3333 43.6 48.3333 47.8667Z"
        fill="black"
      />
    </svg>
  );
};

export default SurveryResults;
